const dashboard = [
  {
    header: 'Apps & Pages',
  },
  {
    title: 'Dashboard',
    icon: 'PieChartIcon',
    enableFeature: true,
    children: [
      {
        title: 'Executive Dashboard',
        route: 'executive-dashboard',
        enableFeature: true,
        hasPermission: 'VIEW_EXECUTIVE_DASHBOARD',
      },
      {
        title: 'Dashboard',
        route: 'dashboard',
        enableFeature: true,
        hasPermission: 'VIEW_BASIC_DASHBOARD',
      },
      {
        title: 'PFI Dashboard',
        route: 'pfi-dashboard',
        enableFeature: true,
        hasPermission: 'VIEW_PFI_DASHBOARD',
      },
      {
        title: 'Admin Dashboard',
        route: 'admin-dashboard',
        enableFeature: true,
        hasPermission: 'VIEW_ADMIN_APPROVALS',
      },
    ],
  },
]
export default dashboard
